import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { axiosAuth } from "../config/axiosInstances"
import { API_XANO_CERTIFIED_BASE_URL } from "../config/api_config"
import { Api_url } from "../common/api_url"

const initialState = {
    aiCourseModalOpened: false,
    leadershipSkillsModalOpened: false,
    softSkillModalOpened: false,
    unlimitedAccessToCourseModalOpened: false,
    cvRevampModalOpened: false,
    hiringPartnersModalOpened: false,
    projectsModalOpened: false,
    interviewGuranteeModalOpened: false,
    title: '',
    learners: 0,
    data: {},
    loading: false
}

export const fetchNewAddonsModalData = createAsyncThunk(
    'fetchNewAddonsModalData',
    async ({ certified_user_skill_quiz_id, addon_id }) => {
        try {
            const response = await axiosAuth.get(API_XANO_CERTIFIED_BASE_URL + Api_url.AddOnData, {
                params: {
                    addon_id,
                    certified_user_skill_quiz_id
                }
            })
            if(response.data?.status === 'sucess'){
                return response.data
            }else{
                return {
                    data: {
                        generated_benefits: [],
                        deliverables: []
                    }
                }
            }
        } catch (error) {
            console.log(error.message)
            throw error
        }
    }
)

const secondTransactionModalSlice = createSlice({
    name: 'secondTransactionModalDetails',
    initialState,
    reducers: {
        setModalOpen: (state, action) => {
            const { id, value } = action.payload
            switch(id){
                case 53:
                    state.aiCourseModalOpened = value
                    return
                case 54:
                    state.leadershipSkillsModalOpened = value
                    return
                case 55:
                    state.softSkillModalOpened = value
                    return
                case 56:
                    state.hiringPartnersModalOpened = value
                    return
                case 57:
                    state.unlimitedAccessToCourseModalOpened = value
                    return
                case 58:
                    state.cvRevampModalOpened = value
                    return
                case 59:
                    state.projectsModalOpened = value
                    return
                case 62:
                    state.interviewGuranteeModalOpened = value
                    return
                default:
                    return
            }
        },
        setModalDetails: (state, action) => {
            state.title = action.payload
            state.learners = (Math.random() * 0.5) + 1.5
        },
        resetModalDetails: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNewAddonsModalData.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchNewAddonsModalData.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload?.data
            })
            .addCase(fetchNewAddonsModalData.rejected, (state, action) => {
                state.loading = false
            })
    }
})

export const { setModalDetails, resetModalDetails, setModalOpen } = secondTransactionModalSlice.actions
export const selectAICourseModalStatus = (state) => state.secondTransactionModalDetails.aiCourseModalOpened
export const selectCVRevampModalOpened = (state) => state.secondTransactionModalDetails.cvRevampModalOpened
export const selectHiringPartnersModalOpened = (state) => state.secondTransactionModalDetails.hiringPartnersModalOpened
export const selectUnlimitedAccessToCourseModalOpened = (state) => state.secondTransactionModalDetails.unlimitedAccessToCourseModalOpened
export const selectSoftSkillModalOpened = (state) => state.secondTransactionModalDetails.softSkillModalOpened
export const selectLeadershipSkillsModalOpened = (state) => state.secondTransactionModalDetails.leadershipSkillsModalOpened
export const selectProjectsModalOpened = (state) => state.secondTransactionModalDetails.projectsModalOpened
export const selectInterviewGuranteeModalOpened = (state) => state.secondTransactionModalDetails.interviewGuranteeModalOpened
export const selectModalTitle = (state) => state.secondTransactionModalDetails.title
export const selectModalUsers = (state) => state.secondTransactionModalDetails.learners
export const selectModalData = (state) => state.secondTransactionModalDetails.data
export const selectModalLoadingStatus = (state) => state.secondTransactionModalDetails.loading
export default secondTransactionModalSlice.reducer